import { DeviceOs } from '../types/entities'

export const useDeviceType = (device?: 'desktop' | 'mobile', deviceOs?: DeviceOs) => {
	const desktop = device === 'desktop'
	const ios = deviceOs === 'ios'

	return { desktop, ios }
}
